(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-studio-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizePath = (path) => path.replace(/\/+$/, '') || '/';
    const isCollectionStateKey = (key) =>
      key === 'brand' || key === 'category' || key === 'sort_by' || key.startsWith('filter.');
    const hasCollectionState = (params) => Array.from(params.keys()).some(isCollectionStateKey);

    const linkMatchesCurrentUrl = (link, currentUrl) => {
      const targetUrl = new URL(link.href, currentUrl.origin);
      if (targetUrl.origin !== currentUrl.origin) return false;
      if (normalizePath(targetUrl.pathname) !== normalizePath(currentUrl.pathname)) return false;

      if (targetUrl.searchParams.toString()) {
        for (const [key, value] of targetUrl.searchParams) {
          if (!currentUrl.searchParams.getAll(key).includes(value)) return false;
        }
        return true;
      }

      return !hasCollectionState(currentUrl.searchParams);
    };

    const updateActiveNavigation = () => {
      const currentUrl = new URL(window.location.href);
      const shopTrigger = document.querySelector('[data-si-shop-trigger]');
      const shopPaths = new Set(
        Array.from(document.querySelectorAll('[data-si-shop-option]'))
          .filter((link) => link instanceof HTMLAnchorElement)
          .map((link) => normalizePath(new URL(link.href, currentUrl.origin).pathname))
      );
      if (shopTrigger instanceof HTMLAnchorElement) {
        shopPaths.add(normalizePath(new URL(shopTrigger.href, currentUrl.origin).pathname));
      }

      for (const link of document.querySelectorAll('[data-si-nav-link]')) {
        if (!(link instanceof HTMLAnchorElement)) continue;
        if (linkMatchesCurrentUrl(link, currentUrl)) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      }

      const shopIsCurrent =
        shopPaths.has(normalizePath(currentUrl.pathname)) &&
        currentUrl.searchParams.get('sort_by') !== 'created-descending';

      for (const trigger of document.querySelectorAll('[data-si-shop-trigger]')) {
        if (!(trigger instanceof HTMLAnchorElement)) continue;
        if (shopIsCurrent) {
          trigger.setAttribute('aria-current', 'page');
        } else {
          trigger.removeAttribute('aria-current');
        }
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateActiveNavigation, { once: true });
    } else {
      updateActiveNavigation();
    }

    window.addEventListener('pageshow', updateActiveNavigation);
    window.addEventListener('popstate', updateActiveNavigation);
    document.addEventListener('shopify:section:load', updateActiveNavigation);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-studio-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-si-recently-viewed]').forEach(async (section) => {
    const dataNode = section.querySelector('[data-si-current-product]');
    const grid = section.querySelector('[data-si-recent-grid]');
    if (!dataNode || !grid) return;
    let current;
    let items;
    try {
      current = JSON.parse(dataNode.textContent);
      items = JSON.parse(localStorage.getItem('si-studio-recent-products') || '[]');
    } catch (error) {
      return;
    }
    const history = Array.isArray(items) ? items.filter((item) => item && item.id !== current.id).slice(0, 4) : [];
    const previous = (await Promise.all(history.map(async (item) => {
      try {
        const url = new URL(item.url, window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return null;
        const response = await fetch(`${url.pathname.replace(/\/$/, '')}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        const product = await response.json();
        const variant = product.variants.find((entry) => entry.available) || product.variants[0];
        if (!variant) return null;
        return { ...item, title: product.title, vendor: product.vendor, image: product.featured_image || item.image, price: variant.price, compareAt: variant.compare_at_price || 0 };
      } catch (error) {
        return null;
      }
    }))).filter(Boolean);
    const saveTemplate = section.dataset.siSaveTemplate || 'Save __PERCENT__%';
    const currency = window.Shopify?.currency?.active || 'USD';
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency });
    previous.forEach((item) => {
      const article = document.createElement('article');
      article.className = 'si-product-card';
      const mediaLink = document.createElement('a');
      mediaLink.className = 'si-product-card__media';
      mediaLink.href = item.url;
      mediaLink.setAttribute('aria-label', item.title);
      if (item.image) {
        const image = document.createElement('img');
        image.className = 'si-product-card__image si-product-card__image--primary';
        image.loading = 'lazy';
        image.src = item.image;
        image.alt = item.title;
        mediaLink.appendChild(image);
      }
      const details = document.createElement('div');
      details.className = 'si-product-card__details';
      const vendor = document.createElement('p');
      vendor.className = 'si-product-card__brand';
      vendor.textContent = item.vendor || '';
      const heading = document.createElement('h3');
      const titleLink = document.createElement('a');
      titleLink.href = item.url;
      titleLink.textContent = item.title;
      heading.appendChild(titleLink);
      const price = document.createElement('div');
      price.className = 'si-product-card__price';
      const currentPrice = Number(item.price || 0);
      const compareAt = Number(item.compareAt || 0);
      const priceText = document.createElement('span');
      priceText.textContent = formatter.format(currentPrice / 100);
      if (compareAt > currentPrice) {
        priceText.className = 'si-price__sale';
        const compareText = document.createElement('s');
        compareText.className = 'si-price__compare';
        compareText.textContent = formatter.format(compareAt / 100);
        const saving = document.createElement('span');
        saving.className = 'si-discount-pill';
        saving.textContent = saveTemplate.replace('__PERCENT__', Math.round(((compareAt - currentPrice) * 100) / compareAt));
        price.append(priceText, compareText, saving);
      } else {
        price.appendChild(priceText);
      }
      details.append(vendor, heading, price);
      article.append(mediaLink, details);
      grid.appendChild(article);
    });
    if (previous.length) section.hidden = false;
    const nextItems = [current, ...items.filter((item) => item.id !== current.id)].slice(0, 8);
    try {
      localStorage.setItem('si-studio-recent-products', JSON.stringify(nextItems));
    } catch (error) {
      return;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
